var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchwherever(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#FF4A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.552 20.173v17.379H12.448v-17.38a2.414 2.414 0 012.414-2.413h20.276a2.414 2.414 0 012.414 2.414z",
    fill: "#CCDCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.759 39h-19.31c-.8 0-1.449-.648-1.449-1.448v-1.449h9.655l.966.966h6.758l.966-.966H39v1.449c0 .8-.648 1.448-1.448 1.448h-5.793z",
    fill: "#ABBAC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.38 19.69h21.24v14.482H14.38V19.69z",
    fill: "#0093BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.62 19.69H31.76L17.276 34.171H35.62V19.69z",
    fill: "#047FA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.69 27.896h10.62a1.931 1.931 0 010 3.863H19.69a1.931 1.931 0 010-3.863z",
    fill: "#FFC119"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.31 27.896h-6.758l-3.863 3.863H30.31a1.931 1.931 0 000-3.863z",
    fill: "#FAAC2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.069 17.759v-2.897a1.931 1.931 0 013.862 0h1.93a3.862 3.862 0 10-7.723 0v2.897h1.93z",
    fill: "#CCDCE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.793 17.759a.966.966 0 00-.965-.966h-9.655a.966.966 0 00-.966.966v6.758c0 .533.432.966.965.966h5.794l4.827-4.828v-2.896z",
    fill: "#FFC119"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.965 25.483h3.862a.966.966 0 00.966-.966v-3.862l-4.828 4.828z",
    fill: "#FAAC2B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.449 20.655a1.448 1.448 0 11-2.897 0 1.448 1.448 0 012.897 0z",
    fill: "#EA732D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.518 21.621h.965v1.931h-.965v-1.93zM19.69 29.345h.965v.965h-.965v-.965zM21.621 29.345h.966v.965h-.966v-.965zM23.552 29.345h.966v.965h-.966v-.965zM25.483 29.345h.965v.965h-.965v-.965z",
    fill: "#EA732D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.207 25.965a3.38 3.38 0 11-6.759 0 3.38 3.38 0 016.759 0z",
    fill: "#EB4042"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.828 27.413a.483.483 0 01-.342-.141l-1.448-1.448.683-.683 1.107 1.107 3.038-3.038.682.683-3.379 3.379a.483.483 0 01-.341.141z",
    fill: "#E9F0F1"
  })));
}
export default "/_next/static/media/launchwherever.eaf9d666a9c5cdfde4d123e795b7d44a.svg";
export { SvgLaunchwherever as ReactComponent };